import mountScript from "./mountScript";
export default mountScript;